export default "__VITE_ASSET__CsCoU$R8__"